import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'wg-fe-ui';

import { Button, Box, Stack } from '@wegroup/design-system';
import CarSearchInputFields from './CarSearchInputFields';

interface Props {
  // Value
  value?: string;
  setValue: (newValue: string) => void;
  example?: string | ReactElement;
  maxWidth?: string | number;

  // Validation
  inputPattern?: string;
  inputMaxLength?: number;
  validationError?: string | false;

  // Bools
  isNumberPlate?: boolean;
}

export interface CarSearchInputProps {
  onSearch: (value?: string) => void;
  isLoading: boolean;

  // Status
  warning?: string;
  disabled?: boolean;
  error?: string | HTMLElement | ReactElement;

  // Others
  className?: string;
}

export type CarSearchInputFieldsProps = Props & CarSearchInputProps;

const CarSearchInput: React.FC<
  React.PropsWithChildren<CarSearchInputFieldsProps>
> = (props) => {
  const { t } = useTranslation();
  const { disabled, onSearch, value, isLoading, error, ...otherProps } = props;

  return (
    <>
      <Stack
        w="100%"
        spacing="4"
        alignItems="stretch"
        direction={{ base: 'column', tablet: 'row' }}
        {...otherProps}
      >
        <CarSearchInputFields {...props} />
        <Button
          isLoading={isLoading}
          isDisabled={disabled || isLoading}
          h={{ base: '12', tablet: '14' }}
          w={{ base: '100%', tablet: '36' }}
          data-test-id="Common_VinSearchInput_Button"
          onClick={() => onSearch(value)}
          sx={{
            '@media print': {
              display: 'none',
            },
          }}
        >
          {t('Search')}
        </Button>
      </Stack>
      {error && (
        <Box mt="20">
          <Alert icon type="error">
            {error}
          </Alert>
        </Box>
      )}
    </>
  );
};

export default CarSearchInput;
